import { AxAgentValues, ListedAxAgent } from '../types';

export const openAgentEditor = ({
  agent,
  hasActiveAgent,
  openProgressor,
}: {
  agent: ListedAxAgent;
  hasActiveAgent: boolean;
  openProgressor: (values?: Partial<AxAgentValues>) => Promise<void>;
}): Promise<void> =>
  openProgressor({
    axAgentId: agent.uuid,
    knowledgeBaseUuid: agent.knowledgeBaseUuid ?? undefined,
    hasActiveAgent,
  });
